import script from "./NewLottertyDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./NewLottertyDetail.vue?vue&type=script&setup=true&lang=js"

import "./NewLottertyDetail.vue?vue&type=style&index=0&id=1d603512&scoped=true&lang=css"

import exportComponent from "D:\\xm\\zhongzai\\qianduan\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d603512"]])

export default __exports__